import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CrudOperationsService } from './crud-operations.service';

@Component({
  selector: 'db-crud-operations-renderer',
  templateUrl: './crud-operations-renderer.component.html',
  styleUrls: ['./crud-operations-renderer.component.scss']
})
export class CrudOperationsRendererComponent implements ICellRendererAngularComp {
  public params: any;
  disableEdit: boolean;

  constructor(private crudOperationsService: CrudOperationsService) { }

  agInit(params: any): void {
    this.disableEdit = false;

    this.params = params;

    if (this.params.colDef.cellRendererParams.operations.edit) {
      this.disableEdit = this.params.data[this.params.colDef.cellRendererParams.operations.edit.disabled];
    }
  }

  refresh(): boolean {
    return false;
  }

  editOperation() {
    this.crudOperationsService.editOperation(this.params);
  }

  cloneOperation() {
    this.crudOperationsService.cloneOperation(this.params);
  }

  answerSetOperation() {
    this.crudOperationsService.answerSetOperation(this.params);
  }
}
